import camelCase from 'lodash/camelCase';
import mapKeys from 'lodash/mapKeys';
import mapValues from 'lodash/mapValues';
import isPlainObject from 'lodash/isPlainObject';

function mapObject(obj, callback) {
  if (Array.isArray(obj)) {
    return obj.map((value) => mapObject(value, callback));
  }

  if (!isPlainObject(obj)) {
    return obj;
  }

  const mappedObject = mapKeys(obj, (value, key) => callback(key));

  return mapValues(mappedObject, (value) => mapObject(value, callback));
}

export default function camelCaseObject(obj) {
  if (!isPlainObject(obj)) {
    return obj;
  }

  return mapObject(obj, camelCase);
}
